import React, { useState, useEffect } from 'react';
import { fetchLeastAcademicGroups, exportLeastAcademicGroupsExcel } from '../services/academicFinanceApi';
import { FinanceTable } from './FinanceTable';
import Notifier from '../../../Utils/notify';
import exporticon from '../../../assets/icons/export-data.svg';

export const LeastAcademicGroupsList = ({ academicGroupId, onLeastAcademicGroupClick, onUpdateGrandTotals }) => {
  const [leastAcademicGroups, setLeastAcademicGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [exporting, setExporting] = useState(false);
  const pageSize = 10;

  useEffect(() => {
    loadLeastAcademicGroups(currentPage);
  }, [currentPage, academicGroupId]);

  const loadLeastAcademicGroups = async (page) => {
    try {
      setLoading(true);
      const data = await fetchLeastAcademicGroups(academicGroupId, page, pageSize);
      setLeastAcademicGroups(data.results || []);
      
      if (data.grand_totals) {
        onUpdateGrandTotals(data.grand_totals);
      }
      
      if (data.count) {
        setTotalPages(Math.ceil(data.count / pageSize));
      }
    } catch (error) {
      console.error('Error loading least academic groups:', error);
      Notifier.error('Failed to load least academic groups');
    } finally {
      setLoading(false);
    }
  };

  const handleExport = async () => {
    try {
      setExporting(true);
      await exportLeastAcademicGroupsExcel(academicGroupId);
      Notifier.success('Least academic groups data exported successfully');
    } catch (error) {
      console.error('Error exporting least academic groups:', error);
      Notifier.error('Failed to export least academic groups data');
    } finally {
      setExporting(false);
    }
  };

  const handleRowClick = (leastAcademicGroup) => {
    onLeastAcademicGroupClick('students', leastAcademicGroup.id, leastAcademicGroup.name);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const columns = [
    { header: 'ID', accessor: 'id', width: '70px' },
    { header: 'LAG Name', accessor: 'name', width: '150px' },
    { header: 'Academic Group', accessor: 'academic_group_name', width: '150px' },
    { header: 'Specialization', accessor: 'specialization_name', width: '150px' },
    { header: 'Course', accessor: 'course_name', width: '120px' },
    { header: 'Alias', accessor: 'course_alias', width: '80px' },
    { 
      header: 'Students', 
      accessor: 'total_students', 
      width: '90px',
      align: 'center'
    },
    { 
      header: 'Imposed', 
      accessor: 'total_imposed_fees', 
      width: '120px',
      align: 'right',
      format: 'currency'
    },
    { 
      header: 'Scheduled', 
      accessor: 'total_scheduled_fee', 
      width: '120px',
      align: 'right',
      format: 'currency'
    },
    { 
      header: 'Paid', 
      accessor: 'total_paid_fees', 
      width: '120px',
      align: 'right',
      format: 'currency'
    },
  ];

  return (
    <div className="least-academic-groups-list">
      <div className="list-header">
        <h2>Least Academic Groups</h2>
        <button 
          className="export-btn" 
          onClick={handleExport}
          disabled={exporting}
        >
          <img src={exporticon} alt="Export" />
          {exporting ? 'Exporting...' : 'Export'}
        </button>
      </div>

      <FinanceTable
        data={leastAcademicGroups}
        columns={columns}
        loading={loading}
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
        onRowClick={handleRowClick}
      />
    </div>
  );
};
